import React from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { Typography } from '@one-thd/sui-atomic-components';
import { TileHead } from '../TileHead';
import { IDS } from '../../../../automationTestIds';

const OffshoreSthUnavailable = ({ stateName = '' }) => {
  return (
    <div className="">
      <TileHead title="Delivery" isUnavailable automationId={IDS.LABEL.sthLabel} />
      <div data-testid="ffm-details-row" className="sui-pt-2">
        <Typography variant="body-base" color="subtle">
          <span data-automation-id={IDS.UA.sth_unavailable}>Unavailable in {stateName}</span>
        </Typography>

      </div>
    </div>
  );
};

OffshoreSthUnavailable.propTypes = {
  stateName: string
};

export { OffshoreSthUnavailable };
